import type { ViewerRouteContext } from "../../../utils/viewerRouteContext";
import { fetchViewerManifest } from "../../../services/viewerManifestService";
import type { ViewerManifestDto } from "./types/viewerManifest.api";

export async function getViewerManifest(
  route: ViewerRouteContext,
): Promise<ViewerManifestDto> {
  const manifest = await fetchViewerManifest(route);

  return {
    companyId: manifest.companyId,
    productId: manifest.productId,
    routeKind: manifest.routeKind,
    viewerMode: manifest.viewerMode,
    releaseId: manifest.releaseId,
    manifestSchemaVersion: manifest.manifestSchemaVersion,
    manifestChecksumSha256: manifest.manifestChecksumSha256,
    sourceVersion: manifest.sourceVersion,
    contentVersion: manifest.contentVersion,
    manifestVersion: manifest.manifestVersion,
    projectState: manifest.projectState,
    brandId: manifest.brandId,
    modelKey: manifest.modelKey,
    modelUrl: manifest.modelUrl,
    previewExpiresAt: manifest.previewExpiresAt,
  };
}

export const fetchViewerRuntimeManifest = getViewerManifest;
